import { Button as RACButton } from 'react-aria-components';

import { Icon } from '../../assets/Icon/Icon';
import {
  arrowsColor,
  getControlVariantCompoundVariants,
} from '../../controls/Button/Button.styles';
import { selectors, transitions } from '../../controls/shared/styles';
import {
  controlArrowsSize,
  controlBorderRadius,
  controlGap,
  controlHeight,
  controlPaddingX,
  controlPaddingY,
  controlVars,
} from '../../controls/shared/vars';
import { colors, darkThemeSelector, shadows, styled } from '../../stitches.config';

export const SelectContainer = styled('div');
SelectContainer.displayName = 'SelectContainer';

export const SelectArrows = styled(Icon, {
  size: controlArrowsSize,
  color: arrowsColor,
});
SelectArrows.displayName = 'SelectArrows';

export const SelectTrigger = styled(RACButton, {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: controlGap,
  heightAll: controlHeight,
  paddingX: controlPaddingX,
  paddingY: controlPaddingY,
  borderRadius: controlBorderRadius,
  opacity: 1,
  truncate: true,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  transition: transitions.control,

  // used to identify as select dropdown for autofocus
  '&': {
    '[data-select-dropdown]': 'true',
  },

  [selectors.focus]: {
    outline: 'none',
  },

  variants: {
    ...controlVars,
    appearance: {
      muted: {},
      vivid: {},
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.5,
      },
      false: {},
    },
    variant: {
      alternative: {},
      attention: {},
      brand: {},
      negative: {},
      neutral: {},
      positive: {},
    },
    ghost: {
      true: {},
      false: {},
    },
    invalid: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    ...getControlVariantCompoundVariants(),

    // Invalid
    {
      isDisabled: false,
      invalid: true,
      css: {
        boxShadow: shadows.fieldErrorLight,

        '&:hover:not(:focus)': {
          boxShadow: shadows.fieldErrorLight,
        },

        [darkThemeSelector]: {
          boxShadow: shadows.fieldErrorDark,

          '&:hover:not(:focus)': {
            boxShadow: shadows.fieldErrorDark,
          },
        },
      },
    },

    // Ghost
    {
      ghost: true,
      css: {
        '&[data-ghost="true"]:not(:hover, :focus, :focus-visible, :focus-within)': {
          backgroundColor: colors.transparent,
          boxShadow: colors.transparent,
          outlineColor: colors.transparent,
        },
      },
    },
  ],
});
SelectTrigger.displayName = 'SelectTrigger';
